<template>
  <!-- プルダウン選択用メッセージ -->
  <div :class="{'my-box': speaker === 'my', 'other-box': speaker === 'other'}">
    <!-- プルダウン選択用メッセージ other -->
    <div class="message"
        :style="{
        'background' : speaker === 'my' ? color.balloonMy : color.balloonOtr + '!important',
        'color'      : autoColor(speaker === 'my' ? color.balloonMy : color.balloonOtr),
        'filter'     : shadowStyle(color.shadowType)}">
      <p class="message-title">{{pulldownMessageCreate(message)}}</p>
      <!-- プルダウン -->
      <div v-for="(pulldown, index) in structuredPulldowns" :key="index">
        <!-- 横並び表示 -->
        <div style="display: flex; flex-wrap: wrap; padding: 8px 0; overflow: scroll;" v-if="pulldown.length > 0">
          <div style="padding: 0 4px 4px 4px;" v-for="(child, idx) in pulldown" :key="idx">
            <p style="font-size: 13px;" v-if="pulldown[0].isDispNextTitle || idx === 0">
              <span class="require" v-if="child.isRequired">*</span>
              {{messageEscape(child.title ? child.title : '-')}}
            </p>
            <p style="font-size: 13px;" v-else><br></p>
            <b-select size="is-small" v-model="selectItems[child.pullDownId]" @input="updateSelect()">
              <option v-for="(item, itemIdx) in child.items" :value="item.itemId" :key="itemIdx">
                {{messageEscape(item.itemName)}}
              </option>
            </b-select>
          </div>
        </div>
      </div>
      <hr>
      <div class="field">
        <button class="button is-fullwidth is-primary" @click="pulldownSubmit(selectItems, isBot, 0)" v-if="!isNowButton()">送信</button>
      </div>
    </div>
  </div>
</template>

<script>
// 外部関数
import hex2rgb from '@/functions/hex2rgb'
import {
  autoColor,
  shadowStyle,
  pulldownMessageCreate,
  messageEscape,
  isNowButton
} from '@/functions/balloonFunc'

export default {
  name: 'PullDownParts',
  props: ['message', 'parameter', 'speaker', 'color', 'lastIndex', 'logIndex', 'isBot', 'isDemo', 'roboArguments'],
  computed: {
    structuredPulldowns () {

      // 連動する子要素を取得
      const getChildren = (id) => {
        let pulldowns = undefined
        if (id == null) {
          pulldowns = this.parameter.filter((pd)=>pd.refPullDownId == '' || pd.refPullDownId == 'None')
        }
        else {
          pulldowns = this.parameter.filter((pd)=>pd.refPullDownId == id)
        }
        // 再帰的に子要素を取得
        return pulldowns.map((pd) => {return {'param':pd, 'children': getChildren(pd.pullDownId)}})
      }

      // 横並び設定を考慮して構造化
      const structure = (pds) => {
        let rows = []
        let row = []
        for (const pd of pds) {
          if (this.isHideItem(pd['param'])) continue
          row.push(pd['param'])
          if (!pd['param'].isLinking) {
            // 横並びしないならその行は終了
            rows.push(row)
            row = []
          }
          if (pd['children'].length !== 0) {
            // 子要素を構造化
            let child_strc = structure(pd['children'])
            if (child_strc.length == 0) {
              rows.push(row)
            }
            else {
              // 子要素の1行目を前と結合(横並び)
              child_strc[0] = row.concat(child_strc[0])
              rows.push(...child_strc)
            }
            row = []
          }
        }
        if (row.length > 0) rows.push(row)
        return rows
      }

      const pulldowns = getChildren(null)
      return structure(pulldowns)
    }
  },
  data () {
    return {
      selectItems: {},
      dispPullDown: []
    }
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    pulldownMessageCreate (m) {
      return pulldownMessageCreate(m, this.roboArguments)
    },
    messageEscape (m) {
      return messageEscape(m, this.roboArguments)
    },
    isHideItem(pulldown) {
      return pulldown.refPullDownId !== 'None' && pulldown.refPullDownId !== '' && pulldown.refItemId !== this.selectItems[pulldown.refPullDownId]
    },
    updateSelect() {
      // 不要な(非表示になった)項目をフィルターで削除
      this.selectItems = Object.assign(
        ...Object.keys(this.selectItems)
        .filter((key) => {
          const pd = this.parameter.find((pd) => pd.pullDownId == key)
          return !this.isHideItem(pd)
        })
        .map((key)=> {return {[key]: this.selectItems[key]}})
      )
    },
    pulldownSubmit (selectItems, isBot, idx) {
      let selectList = []
      let message = []
      let isError = false
      // 未選択チェック
      isError = this.structuredPulldowns.some(
        (row) => row.some(
          (pd) => pd.isRequired && !this.selectItems[pd.pullDownId]
        )
      )
      if (!isError) {
        for (const param of this.parameter) {
          if (this.selectItems[param.pullDownId]) {
            const itemName = param.items.find(
              (item) => item.itemId == this.selectItems[param.pullDownId]
            ).itemName
            const select = '・' + param.title + '：' + itemName
            message.push(select)
            selectList.push(itemName)
          } else {
            selectList.push(null)
          }
        }
        if (message.length === 0) message.push('未選択')
        const submit = {
          subscribeMessage: messageEscape(message.join('\n')),
          quoteAnswers: Object.assign({}, ...selectList.map((item, idx) => ({['pulldown'+(idx+1)]: item})))// 引用置換および応募者情報登録の兼用
        }
        this.$emit('pulldownSubmit', submit, isBot, idx)
      } else {
        alert('必須項目が選択されていません。')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  font-size: medium;
  border-radius: 8px;
  transition: 0.7s;
}
.message > .message-title {
  text-align: left;
  filter: none;
  font-size: smaller;
  word-wrap: break-word;
  margin-bottom: 8px;
  white-space: pre-wrap;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
.require {
  color: red;
  margin-right: 2px;
}
/* Animation */
@for $i from 0 through 6 {
  $enter-delay: 300ms;
  &.slide-button-#{$i} {
    // opacity: 1;
    animation-duration: #{200ms * ($i + 1)};
    animation-name: slide-in;
  }
}
@keyframes slide-in {
  0% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  70% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  100% {
    // opacity: 1;
    transform: scale(1) translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/PullDownParts.vue